'use strict';

module.exports = function() {
  return /url\(.*?\)/ig;
}



//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/functions/postcss/css-shorthand-expand/node_modules/css-url-regex/index.js
// module id = 663
// module chunks = 0 1